/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetCourseCompletionsReportOptions, GetCourseCompletionsReportStatus200, GetCourseCompletionsReportStatus422 } from '../models/GetCourseCompletionsReport'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getCourseCompletionsReport } from '../clients/axios/getCourseCompletionsReport'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCourseCompletionsReportQueryKey = ({ query }: Omit<GetCourseCompletionsReportOptions, 'headers'>) => [{ url: '/reports/course_completions' }, ...(query ? [query] : [])] as const

type GetCourseCompletionsReportQueryKey = ReturnType<typeof getCourseCompletionsReportQueryKey>

export function getCourseCompletionsReportQueryOptions({ query }: GetCourseCompletionsReportOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getCourseCompletionsReportQueryKey({ query })
  return queryOptions<GetCourseCompletionsReportStatus200, ResponseErrorConfig<GetCourseCompletionsReportStatus422>, GetCourseCompletionsReportStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getCourseCompletionsReport({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Course Completions
 * {@link /reports/course_completions}
 */
export function useGetCourseCompletionsReport<TData = GetCourseCompletionsReportStatus200, TQueryData = GetCourseCompletionsReportStatus200, TQueryKey extends QueryKey = GetCourseCompletionsReportQueryKey>({ query }: { query: GetCourseCompletionsReportOptions['query'] | (() => GetCourseCompletionsReportOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<GetCourseCompletionsReportStatus200, ResponseErrorConfig<GetCourseCompletionsReportStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getCourseCompletionsReportQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getCourseCompletionsReportQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetCourseCompletionsReportStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
